import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { ErrorMessage } from './HelpfulFunction';
import '../../styles/css/DropzoneCSS.css'

export default class BasicDropzone extends Component {
    state = {
        loading: false,
        preview: null,
    }

    componentWillUnmount() {
        if (this.state.preview) {
            URL.revokeObjectURL(this.state.preview);
        }
    }

    onDrop = async files => {
        const {
            name,
            uploadFn,
            onUploaded,
            onUploadStart,
            onUploadComplete
        } = this.props;
        const file = files[0]
        if (!file) return

        this.setState({ loading: true })
        onUploadStart && onUploadStart()

        try {
            const res = await uploadFn(file)

            if (res.error) {
                ErrorMessage.fire({title: 'Image cannot be uploaded', text: res.error})
                return
            }

            if (this.state.preview) {
                URL.revokeObjectURL(this.state.preview)
            }

            // success!
            const preview = URL.createObjectURL(file)
            this.setState({ preview })
            onUploaded && onUploaded(name, res.imageUrl, { file, preview })
        } catch (err) {
            ErrorMessage.fire({title: 'Image cannot be uploaded', text: err?.message || 'Please try again.'})
        } finally {
            this.setState({ loading: false })
            onUploadComplete && onUploadComplete()
        }
    }

    clear = () => {
        const { name, onUploaded } = this.props;
        if (this.state.preview) {
            URL.revokeObjectURL(this.state.preview)
        }
        this.setState({ preview: null })
        onUploaded && onUploaded(name, '', null)
    }


    render() {
        const { accept, maxSize, multiple, value, label } = this.props
        const { loading, preview } = this.state
        // react-dropzone v14 expects `accept` as an object ({'image/*': []}); normalize a
        // string ("image/*") so callers passing a string still get proper file-type filtering.
        const normalizedAccept = typeof accept === 'string' ? { [accept]: [] } : accept

        return (
            <div className="basic-dropzone-wrapper">
                {label && <div className="dropzone-label">{label}</div>}
                <Dropzone
                    onDrop={(accepted, rejected) => {
                        if (rejected.length) {
                            ErrorMessage.fire({
                                title: 'Image cannot be uploaded',
                                text: 'Make sure the image is less than 2 MB and of an accepted file type'
                            })
                            return;
                        }
                        this.onDrop(accepted)
                    }}
                    accept={normalizedAccept}
                    maxSize={maxSize}
                    multiple={multiple}
                >
                    {({ getRootProps, getInputProps }) => (
                        <section className="container">
                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input {...getInputProps()} />

                                {loading ? (
                                    <div className="spinner">Uploading…</div>
                                ) : preview || value ? (
                                    <>
                                        <span
                                            className="clear-btn"
                                            onClick={ e => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                this.clear();
                                            }}
                                        >
                                            ❌
                                        </span>
                                        <img src={preview || value} alt="preview" style={{maxWidth: '100%', marginTop: 40, maxHeight: 300}} />
                                    </>
                                ) : (
                                    <p>Drag & drop an image here, or click to select one</p>
                                )}
                            </div>
                        </section>
                    )}
                </Dropzone>
            </div>
        )
    }
}
